export default __webpack_public_path__ + "static/media/Benchmarks_white.687acb0d.svg";